/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-self-assign */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Grid,
  Link,
  Snackbar,
  Tab,
  Tabs,
  Typography,
  Paper,
} from "@mui/material";

import { Box, spacing } from "@mui/system";
import { connect } from "react-redux";

import CreatedTasks from "./createdTasks";
import axios from "../../CustomAxios";
import AssignedTasks from "./assignedTasks";
import AllTasks from "./allTasks";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

function ViewTasks({ auths }) {
  const [loader, setLoader] = useState(false);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [queryType, setQueryType] = useState("assigned_to");
  const [tasks, setTasks] = useState(null);
  const [dupTasks, setDupTasks] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState(
    searchParams.get("search_keyword") || ""
  );

  const [onSearch, setOnSearch] = useState(false);

  const [value, setValue] = useState(authData && 0);
  const [apUsers, setApUsers] = useState(null);
  const [jobs, setJobs] = useState(null);

  const snackRef = useRef(null);

  const [page, setPage] = React.useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 10
  );
  const [total, setTotal] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    changeParams(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    changeParams(0, event.target.value);
  };

  const changeParams = (queryPage, queryLimit) => {
    let query = `?`;

    let assignedTo = searchParams.get("assigned_to");
    let createdBy = searchParams.get("created_by");
    let associatedJob = searchParams.get("associated_job");
    let status = searchParams.get("status");
    let deadline = searchParams.get("deadline");
    let search_keyword = searchParams.get("search_keyword");

    if (assignedTo) {
      query += `&assigned_to=${assignedTo}`;
    }
    if (createdBy) {
      query += `&created_by=${createdBy}`;
    }
    if (associatedJob) {
      query += `&associated_job=${associatedJob}`;
    }
    if (status) {
      query += `&status=${status}`;
    }
    if (deadline) {
      query += `&deadline=${deadline}`;
    }
    if (search_keyword) {
      query += `&search_keyword=${search_keyword}`;
    }

    query += `&page=${queryPage}&limit=${queryLimit}`;

    navigate("/dashboard/tasks" + query, {
      replace: true,
    });
  };

  // for snack ref and errors
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);

  const [filterData, setFilterData] = useState({
    filtered: false,
    assignedTo: searchParams.get("assigned_to"),
    associatedJob: searchParams.get("associated_job"),
    deadline: searchParams.get("deadline"),
    createdBy: searchParams.get("created_by"),
    status: searchParams.get("status"),
  });

  const handleChange = (event, newValue) => {
    setSearchKeyword("");
    if (newValue === 0) {
      setQueryType("assigned_to");
    } else if (newValue === 1) {
      setQueryType("created_by");
    } else {
      setQueryType("all_tasks");
    }
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div {...other}>{value === index && <Box p={3}>{children}</Box>}</div>
    );
  }

  const getTasks = async (searchKeyword = "") => {
    let assignedTo = searchParams.get("assigned_to");
    let createdBy = searchParams.get("created_by");
    let associatedJob = searchParams.get("associated_job");
    let status = searchParams.get("status");
    let deadline = searchParams.get("deadline");
    let search_keyword = searchParams.get("search_keyword");
    let queryPage = searchParams.get("page");
    let queryLimit = searchParams.get("limit");

    let url = `/api/v1/${authData?.type}/tasks?`;
    url += queryType + "=" + authData.user_id;

    if (assignedTo) {
      url += `&assigned_to=${assignedTo}`;
    }
    if (createdBy) {
      url += `&created_by=${createdBy}`;
    }
    if (associatedJob) {
      url += `&associated_job=${associatedJob}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    if (deadline) {
      url += `&deadline=${deadline}`;
    }

    if (!searchKeyword) {
      url += `&search_keyword=${search_keyword ? searchKeyword : ""}`;
    } else {
      url += `&search_keyword=${searchKeyword ? searchKeyword : ""}`;
    }

    queryPage ? (queryPage = Number(queryPage) + 1) : (queryPage = page + 1);
    queryLimit ? (queryLimit = queryLimit) : (queryLimit = rowsPerPage);

    url += `&page=${queryPage}&limit=${queryLimit}`;

    // alert(url);

    setLoader(true);
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const fetchedTasks = await axios.get(url, config);
      if (fetchedTasks.data.success) {
        setTotal(fetchedTasks.data.data.metadata.total_results);
        setTasks(fetchedTasks.data.data.data);
        setDupTasks(fetchedTasks.data.data.data);
      }
      setLoader(false);
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  const onUpdateStatus = async (status, taksId) => {
    setLoader(true);
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      let url = `/api/v1/${authData?.type}/tasks/update-status`;

      const result = await axios.post(
        url,
        { status: status, task_id: taksId },
        config
      );
      if (result.data.success) {
        getTasks();
        setSuccess(true);
        setErr("");
        snackRef.current.click();
      }
    } catch (e) {
      setLoader(false);
      if (e.response) {
        if (e.response && e.response.data && e.response.data.message) {
          setErr(e.response.data.message);
        } else {
          setErr("Server Error");
        }
        snackRef.current.click();
      }
    }
  };

  const getApUsersAndJobs = async () => {
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      let url = `/api/v1/${authData?.type}/tasks/get-apusers?page=1&limit=1000`;

      const apUsers = await axios.get(url, config);
      if (apUsers.data.success) {
        let finalData = apUsers.data.data.data;
        // let notIncludedPresentUser = apUsers.data.data.data.filter(
        //   (d) => d._id !== userData.user_id
        // );

        if (authData.type === "super_admin") {
          let user = {
            name: "super_admin",
            _id: authData.user_id,
          };
          finalData.push(user);
        }

        let presentUserIndex = finalData.findIndex(
          (u) => u._id === authData.user_id
        );
        if (presentUserIndex >= 0) {
          finalData[presentUserIndex].name = "YOURSELF";
          finalData.forEach(function (item, i) {
            if (item._id === authData.user_id) {
              finalData.splice(i, 1);
              finalData.unshift(item);
            }
          });
        }
        setApUsers(finalData);
      }

      const { data } = await axios.get(
        `/api/v1/${authData?.type}/tasks/get-jobs?limit=1000`,
        config
      );
      if (data.success) {
        setJobs(data.data.data);
      }
      setLoader(false);
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  const setFilters = async (
    assignedTo,
    createdBy,
    associatedJob,
    status,
    deadline,
    search
  ) => {
    let query = `?`;

    let url = `/api/v1/${authData?.type}/tasks?`;
    url += queryType + "=" + authData.user_id;

    if (assignedTo) {
      query += `&assigned_to=${assignedTo}`;
      url += `&assigned_to=${assignedTo}`;
    }
    if (createdBy) {
      query += `&created_by=${createdBy}`;
      url += `&created_by=${createdBy}`;
    }
    if (associatedJob) {
      query += `&associated_job=${associatedJob}`;
      url += `&associated_job=${associatedJob}`;
    }
    if (status) {
      query += `&status=${status}`;
      url += `&status=${status}`;
    }
    if (deadline) {
      query += `&deadline=${deadline}`;
      url += `&deadline=${deadline}`;
    }

    if (search) {
      query += `&search_keyword=${search}`;
      url += `&search_keyword=${search}`;
    }
    // query += `&page=${page}&limit=${rowsPerPage}`;

    navigate("/dashboard/tasks" + query, {
      replace: true,
    });
    setPage(0);
    setRowsPerPage(10);
    setLoader(true);
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      let filteredData = {
        assignedTo: assignedTo ? assignedTo : null,
        associatedJob: associatedJob ? associatedJob : null,
        createdBy: createdBy ? createdBy : null,
        deadline: deadline ? deadline : null,
        status: status ? status : null,
        filtered: true,
      };
      setFilterData(filteredData);
      const fetchedTasks = await axios.get(url, config);
      if (fetchedTasks.data.success) {
        setTasks(fetchedTasks.data.data.data);
        setDupTasks(fetchedTasks.data.data.data);
      }
      setLoader(false);
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  useEffect(() => {
    if (onSearch) {
      let query = `?`;
      let assignedTo = searchParams.get("assigned_to");
      let createdBy = searchParams.get("created_by");
      let associatedJob = searchParams.get("associated_job");
      let status = searchParams.get("status");
      let deadline = searchParams.get("deadline");
      let search_keyword = searchKeyword;

      if (assignedTo) {
        query += `&assigned_to=${assignedTo}`;
      }
      if (createdBy) {
        query += `&created_by=${createdBy}`;
      }
      if (associatedJob) {
        query += `&associated_job=${associatedJob}`;
      }
      if (status) {
        query += `&status=${status}`;
      }
      if (deadline) {
        query += `&deadline=${deadline}`;
      }
      if (search_keyword) {
        query += `&search_keyword=${search_keyword}`;
      }

      navigate("/dashboard/tasks" + query, {
        replace: true,
      });
      getTasks(searchKeyword);
      
      setOnSearch(false);
    }
  }, [onSearch]);

  useEffect(() => {
    getApUsersAndJobs();
  }, []);

  useEffect(() => {
    getTasks();
  }, [queryType, page, rowsPerPage]);

  return (
    <React.Fragment>
      <Helmet title="Alpha Plus" />

      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : success ? (
          <Alert mt={2} mb={4} severity="success">
            Status updated Successfully
          </Alert>
        ) : null}
      </Snackbar>

      <Grid
        justifyContent="space-between"
        alignItems="center"
        container
        spacing={10}
        mb={4}
      >
        <Grid item>
          <Typography
            variant="h4"
            gutterBottom
            display="inline"
            sx={{ fontWeight: 600 }}
            color="primary"
          >
            TASKS
          </Typography>
        </Grid>
        <Grid item>
          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/dashboard/tasks">
              Dashboard
            </Link>
            <Typography> Tasks</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>
      <Paper>
        <Box
          ml={6}
          mr={6}
          pt={2}
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tabs value={value} onChange={handleChange}>
            <Tab label="Assigned to you" />
            <Tab label="Created by You" />

            {authData && authData.type === "super_admin" && (
              <Tab label="All Tasks" />
            )}
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <AssignedTasks
            tasks={tasks}
            apUsers={apUsers}
            loader={loader}
            jobs={jobs}
            onUpdateStatus={onUpdateStatus}
            setFilter={setFilters}
            filteredData={filterData}
            searchKeyword={searchKeyword}
            setSearchKeyword={setSearchKeyword}
            setOnSearch={setOnSearch}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            total_results={total}
          />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <CreatedTasks
            tasks={tasks}
            apUsers={apUsers}
            loader={loader}
            jobs={jobs}
            onUpdateStatus={onUpdateStatus}
            setFilter={setFilters}
            filteredData={filterData}
            searchKeyword={searchKeyword}
            setSearchKeyword={setSearchKeyword}
            setOnSearch={setOnSearch}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            total_results={total}
          />
        </TabPanel>

        {authData && authData.type === "super_admin" && (
          <TabPanel value={value} index={2}>
            <AllTasks
              tasks={tasks}
              apUsers={apUsers}
              jobs={jobs}
              loader={loader}
              onUpdateStatus={onUpdateStatus}
              setFilter={setFilters}
              filteredData={filterData}
              searchKeyword={searchKeyword}
              setSearchKeyword={setSearchKeyword}
              page={page}
              setOnSearch={setOnSearch}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
            />
          </TabPanel>
        )}
      </Paper>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(ViewTasks);
